import {
    InputType,
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { CosteModel } from 'src/app/models/coste.model';
import { environment } from 'src/environments/environment';

export class CostesTareasFormDefinition {
    public formType!: FormType;

    public formFields!: Form<CosteModel>;

    public fieldNames: FormField<CosteModel>[] = [];

    public fieldLabels: string[] = [];

    constructor(type: FormType = FormType.INFORMATIVE) {
        this.formType = +type;

        this.formFields = {
            name: 'costes-tareas',
            header: 'Detalle del registro',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<CosteModel>[] {
        return [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getMainFields(),
                order: 1,
            },
        ];
    }

    private getMainFields(): FormField<CosteModel>[] {
        const fields: FormField<CosteModel>[] = [
            this.hiddenField('id', 1),
            this.textField('finca', environment.features.fincaName, 2),
            this.textField('sector', 'Sector', 3),
            this.textField('tarea', 'Tareas', 4),
            this.textField('parcelas', 'Parcela', 5),
            this.textField('fecha', 'Fecha', 6),
            this.textField('hora_inicio', 'Hora inicio', 7, environment.appName === 'ava'),
            this.textField('hora_fin', 'Hora fin', 8, environment.appName === 'ava'),
            this.textField('maquinaria', 'Maquinaria', 9, environment.appName !== 'ava'),
            this.textField('trabajadores_nombres', 'Trabajadores', 10, environment.appName !== 'ava'),
            this.textField('horas', 'Horas', 11, environment.appName !== 'ava'),
        ];

        return this.registerVisibleFields(fields);
    }

    private hiddenField(name: string, order: number): FormField<CosteModel> {
        return {
            name,
            vinculatedFields: undefined,
            label: '',
            input: {
                type: InputType.HIDDEN,
                isEditable: false,
            },
            width: 1,
            conditions: this.conditions(),
            order,
        };
    }

    private textField(name: string, label: string, order: number, isVisible = true): FormField<CosteModel> {
        return {
            name,
            vinculatedFields: undefined,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
            },
            width: 3,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }

    private registerVisibleFields(fields: FormField<CosteModel>[]): FormField<CosteModel>[] {
        for (const field of fields) {
            if (field.conditions.isVisible && field.input.type !== InputType.HIDDEN) {
                this.fieldNames.push(field);
                this.fieldLabels.push(field.label);
            }
        }

        return fields.sort((a, b) => a.order - b.order);
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}
